import { z } from 'zod';
import { orderIdSchema, paymentIdSchema, tenantIdSchema } from '../ids/index.js';
import { cents } from '../money/index.js';
export const paymentMethod = {
    cash: 'cash',
    card: 'card',
    transfer: 'transfer',
    nequi: 'nequi',
    daviplata: 'daviplata',
    credit: 'credit',
};
export const paymentMethodSchema = z.enum(['cash', 'card', 'transfer', 'nequi', 'daviplata', 'credit']);
/** Medios con los que entra dinero real (todos menos `credit`/fiado). Se usan
 * para abonos a cartera. */
export const collectionMethodSchema = z.enum(['cash', 'card', 'transfer', 'nequi', 'daviplata']);
/** Etiquetas UI canónicas. `credit` = venta a crédito (el cliente queda con saldo). */
export const paymentMethodLabels = {
    cash: 'Efectivo',
    card: 'Tarjeta',
    transfer: 'Transferencia',
    nequi: 'Nequi',
    daviplata: 'Daviplata',
    credit: 'Crédito',
};
/** Códigos DIAN oficiales de medio de pago (catálogo DIAN). */
export const dianPaymentCodeByMethod = {
    cash: '10',
    card: '48',
    transfer: '42',
    nequi: '47',
    daviplata: '47',
    credit: '30',
};
export const paymentSchema = z.object({
    id: paymentIdSchema,
    tenantId: tenantIdSchema,
    orderId: orderIdSchema,
    method: paymentMethodSchema,
    amountCents: cents,
    dianPaymentCode: z.string().max(4),
    paymentMeans: z.enum(['contado', 'credito']).default('contado'),
    dueDate: z.number().int().nullable().default(null),
    receivedAt: z.number().int(),
    cashSessionId: z.string().nullable().default(null),
    userId: z.string().nullable().default(null),
    customerId: z.string().nullable().default(null),
    /** Efectivo entregado (solo cash). Cambio = tenderedCents − amountCents. */
    tenderedCents: z.number().int().positive().nullable().default(null),
    version: z.number().int().min(1).default(1),
    createdAt: z.number().int(),
    updatedAt: z.number().int(),
    deletedAt: z.number().int().nullable().default(null),
});
//# sourceMappingURL=payment.js.map